module.exports = __webpack_public_path__ + "static/img/004.854af58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/004.png
// module id = v7FE
// module chunks = 1